import { useState } from "react";
import axios from "axios";
import { Mail, Check, Star } from "lucide-react";
import { API } from "../App";

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle, loading, success, error
  const [plan, setPlan] = useState("free"); // free, premium

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      await axios.post(`${API}/newsletter/subscribe`, {
        email,
        language: 'pt-BR',
        plan
      });
      setStatus("success");
      setEmail("");
      setTimeout(() => setStatus("idle"), 3000);
    } catch (error) {
      console.error("Error subscribing:", error);
      setStatus("error");
      setTimeout(() => setStatus("idle"), 3000);
    }
  };

  return (
    <div className="bg-emerald-900 rounded-xl p-8" data-testid="newsletter-form">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center">
          <Mail className="w-6 h-6 text-white" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-white">Receba Notícias no Email</h3>
          <p className="text-sm text-white/80">Cadastre-se para receber as principais notícias de finanças pessoais diretamente no seu email.</p>
        </div>
      </div>

      {/* Plan Selection */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <button
          onClick={() => setPlan('free')}
          className={`p-4 rounded-lg border-2 transition-all text-left ${
            plan === 'free' 
              ? 'border-white bg-white/10' 
              : 'border-white/20 hover:border-white/40'
          }`}
          data-testid="plan-free"
        >
          <div className="flex items-center gap-2 mb-2">
            <Mail className="w-5 h-5 text-white" />
            <h4 className="font-bold text-white">Plano Gratuito</h4>
          </div>
          <ul className="text-sm text-white/80 space-y-1">
            <li>✓ Resumo semanal</li>
            <li>✓ Principais notícias</li>
          </ul>
        </button>

        <button
          onClick={() => setPlan('premium')}
          className={`p-4 rounded-lg border-2 transition-all text-left ${
            plan === 'premium' 
              ? 'border-amber-400 bg-amber-400/10' 
              : 'border-white/20 hover:border-amber-400/40'
          }`}
          data-testid="plan-premium"
        >
          <div className="flex items-center gap-2 mb-2">
            <Star className="w-5 h-5 text-amber-400" />
            <h4 className="font-bold text-white">Premium</h4>
            <span className="text-xs bg-amber-400 text-slate-900 px-2 py-0.5 rounded-full font-bold">R$ 19,99/mês</span>
          </div>
          <ul className="text-sm text-white/80 space-y-1">
            <li>✓ Tudo do gratuito</li>
            <li>✓ Análises exclusivas</li>
            <li>✓ Alertas em tempo real</li>
          </ul>
        </button>
      </div>

      <form onSubmit={handleSubmit} className="flex gap-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Seu email"
          required
          disabled={status === "loading" || status === "success"}
          className="flex-1 px-4 py-3 rounded-full border-0 focus:outline-none focus:ring-2 focus:ring-white/50"
          data-testid="newsletter-email-input"
        />
        <button
          type="submit"
          disabled={status === "loading" || status === "success"}
          className="px-6 py-3 bg-white text-emerald-900 rounded-full font-medium hover:bg-white/90 transition-colors disabled:opacity-50 flex items-center gap-2"
          data-testid="newsletter-subscribe-button"
        >
          {status === "success" ? (
            <>
              <Check className="w-5 h-5" />
              Email cadastrado com sucesso!
            </>
          ) : (
            "Assinar"
          )}
        </button>
      </form>

      {status === "error" && (
        <p className="text-sm text-red-200 mt-2" data-testid="newsletter-error">
          Erro ao cadastrar email. Tente novamente.
        </p>
      )}

      {plan === 'premium' && (
        <p className="text-xs text-white/60 mt-3 text-center">
          * Após o cadastro, você receberá instruções de pagamento
        </p>
      )}
    </div>
  );
};

export default NewsletterForm;